// @ts-nocheck b17737d5
import addPanelDataConsts from '#packages/addPanelDataConsts';
import coreUtilsLib from 'coreUtilsLib';

const { blogAppPartNames } = coreUtilsLib;

export default {
  type: addPanelDataConsts.SECTIONS_TYPES.PRESET,
  hide: false,
  title: 'add_section_label_ticker',
  showSectionHeader: true,
  additionalBehaviours: {
    labelMode: addPanelDataConsts.LABEL_BEHAVIOUR.NONE,
    infoIcon: addPanelDataConsts.INFO_ICON_BEHAVIOUR.NONE,
    hoverImageAction: addPanelDataConsts.HOVER_IMAGE_ACTIONS.SCALE,
    iconEnabledForComps: {},
  },
  props: {
    image: 'blog/sections/tickerSection.png',
    imageHover: null,
    items: [
      {
        id: 'Blog_Ticker_1',
        structure: {
          type: 'Component',
          skin: 'wysiwyg.viewer.skins.AppPartSkin',
          layout: {
            width: 210,
            height: 220,
            x: -76,
            y: 9,
            scale: 1,
            rotationInDegrees: 0,
            fixedPosition: false,
          },
          componentType: 'wixapps.integration.components.AppPart',
          data: {
            type: 'AppPart',
            metaData: {
              isPreset: false,
              schemaVersion: '1.0',
              isHidden: false,
            },
            appInnerID: '12',
            appPartName: blogAppPartNames.TICKER,
            viewName: 'TickerMediaBottom',
            appLogicCustomizations: [],
            appLogicParams: {},
          },
          props: {
            type: 'AppPartProperties',
            metaData: { schemaVersion: '1.0' },
            direction: 'ltr',
          },
          style: {
            type: 'TopLevelStyle',
            id: 'blog_33a9f5e0-b083-4ccc-b55d-3ca5d241a6eb_1',
            metaData: {
              isPreset: false,
              schemaVersion: '1.0',
              isHidden: false,
            },
            style: {
              groups: {},
              properties: { rd: '7px' },
              propertiesSource: { rd: 'value' },
            },
            componentClassName: '',
            pageId: '',
            compId: '',
            styleType: 'system',
            skin: 'wysiwyg.viewer.skins.AppPartSkin',
          },
          id: 'i74za67m_2',
        },
        preset: { rect: { width: 162, height: 166, x: 0, y: 0 }, label: '' },
      },
      {
        id: 'Blog_Ticker_2',
        structure: {
          type: 'Component',
          skin: 'wysiwyg.viewer.skins.AppPartSkin',
          layout: {
            width: 210,
            height: 220,
            x: 153,
            y: 9,
            scale: 1,
            rotationInDegrees: 0,
            fixedPosition: false,
          },
          componentType: 'wixapps.integration.components.AppPart',
          data: {
            type: 'AppPart',
            metaData: {
              isPreset: false,
              schemaVersion: '1.0',
              isHidden: false,
            },
            appInnerID: '12',
            appPartName: blogAppPartNames.TICKER,
            viewName: 'TickerMediaTop',
            appLogicCustomizations: [],
            appLogicParams: {},
          },
          props: {
            type: 'AppPartProperties',
            metaData: { schemaVersion: '1.0' },
            direction: 'ltr',
          },
          style: {
            type: 'TopLevelStyle',
            id: 'blog_33a9f5e0-b083-4ccc-b55d-3ca5d241a6eb_1',
            metaData: {
              isPreset: false,
              schemaVersion: '1.0',
              isHidden: false,
            },
            style: {
              groups: {},
              properties: { rd: '7px' },
              propertiesSource: { rd: 'value' },
            },
            componentClassName: '',
            pageId: '',
            compId: '',
            styleType: 'system',
            skin: 'wysiwyg.viewer.skins.AppPartSkin',
          },
          id: 'i74za67m_6',
        },
        preset: { rect: { width: 162, height: 165, x: 162, y: 1 }, label: '' },
      },
    ],
    compTypes: ['wixapps.integration.components.AppPart'],
  },
  help: { hide: false, text: 'add_section_info_text_ticker' },
};
